export default "__VITE_ASSET__BQFcUIlQ__"